import { render } from "./ExpandableText.vue?vue&type=template&id=92fc5a60"
import script from "./ExpandableText.vue?vue&type=script&lang=js"
export * from "./ExpandableText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__